import React, { Component } from 'react';

class VerticalAlignment extends Component {
  render() {
    let { value, onChange } = this.props.input;
    return (
      <div className="field is-horizontal">
        <div className="field-label is-small">
          <label className="label">{'  '}</label>
        </div>
        <div className="field-body">
          <div className="field has-addons is-fullwidth">
            <p className="control">
              <button
                type="button"
                className={`button is-small ${value === 'top' ? 'is-active' : ''}`}
                onClick={(e) => {
                  onChange('top');
                }}
              >
                <span className="icon is-small">
                  <i className="fas fa-sort-up"></i>
                </span>
              </button>
            </p>
            <p className="control">
              <button
                type="button"
                className={`button is-small ${
                  value === 'center' ? 'is-active' : ''
                }`}
                onClick={(e) => {
                  onChange('center');
                }}
              >
                <span className="icon is-small">
                  <i className="fas fa-sort"></i>
                </span>
              </button>
            </p>
            <p className="control">
              <button
                type="button"
                className={`button is-small ${
                  value === 'bottom' ? 'is-active' : ''
                }`}
                onClick={(e) => {
                  onChange('bottom');
                }}
              >
                <span className="icon is-small">
                  <i className="fas fa-sort-down"></i>
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
export default VerticalAlignment;
